'use client'

import { useState } from 'react'

import { useModalPlansStore } from '../../../../../store'

import { NoReportsWarning } from '../components'

import { VARIANTS_PLANS, VariantName } from '../../../constants'
import { useAmplitude } from '@wiggot/analytics'
import { EModalServicesAmplitude } from '../../../enum'

export const useLogicModalPlans = () => {
  const isOpen = useModalPlansStore((state) => state.isOpen)
  const defaultVariantName = useModalPlansStore((state) => state.variantName)
  const resetModalPlanStore = useModalPlansStore((state) => state.reset)

  const { trackEvent } = useAmplitude()

  const [checked, setChecked] = useState<boolean>(false)

  const assignedNameVariant = defaultVariantName as VariantName

  const kindAmplitudeVariant =
    VARIANTS_PLANS[assignedNameVariant]?.amplitudeKind

  const handleAmplitudeEvent = () => {
    trackEvent({
      name: EModalServicesAmplitude.TRIAL_START_ACTION,
      eventProperties: {
        kind: kindAmplitudeVariant
      },
      configs: {
        login: true
      }
    })
  }
  const handleModalText = () => {
    switch (assignedNameVariant) {
      case VARIANTS_PLANS.NO_REPORTS_WARNING.name:
        return NoReportsWarning()
      default:
        return ''
    }
  }

  const closeModal = () => {
    handleAmplitudeEvent()
    resetModalPlanStore()
  }

  return {
    handleModalText,
    setChecked,
    closeModal,
    assignedNameVariant,
    checked,
    isOpen,
    handleAmplitudeEvent
  }
}
